module.exports = __webpack_public_path__ + "b7e9f17cfb48c16687cec0c0dd14d4b0.svg";